import styled from 'styled-components'

export const LanguageContainer = styled.div`
  margin-top: 40px;

  display: flex;
  flex-direction: column;
  gap: 15px;

  padding-bottom: 100px;

  > div {
    display: flex;
    flex-wrap: wrap;

    .CheckBox {
      min-width: 50%;
      max-width: 50%;
      margin-bottom: 15px;
    }
  }
`

export const Title = styled.span`
  display: flex;
  align-items: center;
  gap: 5px;
`